const SWIPE_THRESHOLD = 40;

class FounderCarousel extends HTMLElement {
  connectedCallback() {
    this.medias = [...this.querySelectorAll('[data-founder-media]')];
    this.texts = [...this.querySelectorAll('[data-founder-text]')];
    this.dots = [...this.querySelectorAll('[data-founder-dot]')];
    this.prevButton = this.querySelector('[data-founder-prev]');
    this.nextButton = this.querySelector('[data-founder-next]');
    this.stage = this.querySelector('.founder-message__stage');

    if (this.medias.length < 2) return;

    this.index = this.medias.findIndex((media) => media.classList.contains('is-active'));
    if (this.index < 0) this.index = 0;

    this.pointerStartX = null;

    this.handlePrev = () => this.goTo(this.index - 1);
    this.handleNext = () => this.goTo(this.index + 1);
    this.handleDotClick = (event) => this.goTo(Number(event.currentTarget.dataset.founderIndex));
    this.handleKeydown = (event) => {
      if (event.key === 'ArrowLeft') this.handlePrev();
      if (event.key === 'ArrowRight') this.handleNext();
    };
    this.handlePointerDown = (event) => {
      this.pointerStartX = event.clientX;
    };
    this.handlePointerUp = (event) => {
      if (this.pointerStartX === null) return;

      const distance = event.clientX - this.pointerStartX;
      this.pointerStartX = null;

      if (Math.abs(distance) < SWIPE_THRESHOLD) return;

      if (distance < 0) this.handleNext();
      else this.handlePrev();
    };

    this.prevButton?.addEventListener('click', this.handlePrev);
    this.nextButton?.addEventListener('click', this.handleNext);
    for (const dot of this.dots) dot.addEventListener('click', this.handleDotClick);
    this.addEventListener('keydown', this.handleKeydown);
    this.stage?.addEventListener('pointerdown', this.handlePointerDown);
    this.stage?.addEventListener('pointerup', this.handlePointerUp);
    this.stage?.addEventListener('pointercancel', this.handlePointerUp);
  }

  disconnectedCallback() {
    this.prevButton?.removeEventListener('click', this.handlePrev);
    this.nextButton?.removeEventListener('click', this.handleNext);
    for (const dot of this.dots ?? []) dot.removeEventListener('click', this.handleDotClick);
    this.removeEventListener('keydown', this.handleKeydown);
    this.stage?.removeEventListener('pointerdown', this.handlePointerDown);
    this.stage?.removeEventListener('pointerup', this.handlePointerUp);
    this.stage?.removeEventListener('pointercancel', this.handlePointerUp);
  }

  goTo(target) {
    const total = this.medias.length;
    const next = ((target % total) + total) % total;

    if (next === this.index) return;

    this.index = next;

    this.medias.forEach((media, position) => this.setSlideState(media, position === next));
    this.texts.forEach((text, position) => this.setSlideState(text, position === next));

    this.dots.forEach((dot, position) => {
      dot.classList.toggle('is-active', position === next);

      if (position === next) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  setSlideState(element, isActive) {
    element.classList.toggle('is-active', isActive);

    if (isActive) {
      element.removeAttribute('aria-hidden');
      element.removeAttribute('inert');
    } else {
      element.setAttribute('aria-hidden', 'true');
      element.setAttribute('inert', '');
    }
  }
}

if (!customElements.get('founder-carousel')) {
  customElements.define('founder-carousel', FounderCarousel);
}
